// import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { Result, Space, Typography } from 'antd';
import LIEnquirySubmittedIcon from 'assets/images/MakeRequest/sucesspageicon.svg';

// import { useEnquiryEmailSubmission } from 'all-in-one-shared-api';
import { PrimaryButton } from 'components';
// import { useKeycloakReady } from 'hooks/useKeycloakReady';

interface LocationState {
  enquiryReference: string;
  policyNo: string;
  backRoute: string;
}
const GreenSuccessPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { policyNo, enquiryReference, backRoute } = (location.state as LocationState) ?? {};

  // if (!enquiryReference) {
  //   return <Navigate to="/notFound" replace={true} />;
  // }
  const onClick = () => {
    console.log('policyNopolicyNopolicyNo', policyNo);
    navigate(backRoute, {
      state: {
        policyNo: policyNo,
      },
      replace: true,
    });
  };
  return (
    <Result
      className="lifesucess"
      style={{ width: '100%' }}
      title={t('life.MakeRequest.sucsesspagetittle')}
      icon={<img style={{ width: '176px', height: '176px' }} src={LIEnquirySubmittedIcon} />}
      extra={
        <Space direction="vertical">
          {/* <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px', color: '#6f7072' }}>
            <span>{t('life.MakeRequest.sucsesspagetext')}</span>
            <span>{`${t('life.MakeRequest.sucsessNo')}${enquiryReference}`}</span>
          </Typography.Text> */}
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px', color: '#6f7072' }}>
            <span>{t('life.MakeRequest.sucsesspagetext1')}</span>
          </Typography.Text>
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px', color: '#6f7072' }}>
            <span>{t('life.MakeRequest.sucsesspagetext2')}</span>
          </Typography.Text>
          <Typography.Text style={{ fontFamily: 'Roboto400', fontSize: '24px', color: '#6f7072' }}>
            <span>{`${t('life.MakeRequest.sucsesspagetext3')}${enquiryReference}`}</span>
          </Typography.Text>
          <PrimaryButton
            className="sucsesPrimaryButton"
            style={{ height: '56px', fontFamily: 'Roboto500', fontSize: '20px', marginTop: '15px' }}
            onClick={onClick}
          >
            {t('common.done')}
          </PrimaryButton>
        </Space>
      }
    />
  );
};
export default GreenSuccessPage;
